// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "fami-cf32a.firebaseapp.com",
  "projectId": "fami-cf32a",
  "storageBucket": "fami-cf32a.appspot.com",
  "messagingSenderId": "465664991753",
  "appId": "1:465664991753:web:6be2b7975b27f633540ed8",
  "measurementId": "G-KMPFLC09Z7",
  "apiKey": "AIzaSyDm8aVcrV8Q7ZzQ7k_JKzu_awlwr6EkR6M"
};
